export default __webpack_public_path__ + "static/media/wallet.23fe3094.svg";